import { useContext, useEffect } from "react"
import { AuthContext } from "../../context/Auth/AuthContext"
import { SocketContext } from "../../context/Socket/SocketContext"
import { useTicketsStore } from "../../stores/ticketsStore"

const TicketsSocketInitializer = () => {
  const { user } = useContext(AuthContext)
  const socketManager = useContext(SocketContext)

  useEffect(() => {
    if (!user?.id) return

    const companyId = localStorage.getItem("companyId")
    if (!companyId) return

    useTicketsStore.getState().initSocket({
      socketManager,
      companyId,
      user,
    })

    return () => {
      useTicketsStore.getState().destroySocket()
    }
  }, [socketManager, user])

  return null
}

export default TicketsSocketInitializer
